import React, { useEffect, useState } from "react";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import { IconButton, Tooltip } from "@mui/material";
import { t } from "i18next";

const CoreSpeedDial = ({ actions = [], selectedDoc }) => {
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    if (selectedDoc) {
      setHidden(true);
    } else {
      setHidden(false);
    }
  }, [selectedDoc]);

  return (
    <>
      <Tooltip title={t("MassiveActions")}>
        <IconButton
          onClick={() => setHidden(!hidden)}
          size="small"
          className="border border-solid border-gray me-3 "
        >
          <SpeedDialIcon
            className={`${
              hidden ? "rotate-0 duration-300" : "rotate-45 duration-300"
            }`}
          />
        </IconButton>
      </Tooltip>
      <div
        className={`${
          hidden ? "hidden" : ""
        } border border-solid rounded-full border-gray flex overflow-auto `}
        style={{ maxHeight: "42px" }}
      >
        {actions.map((action, index) => (
          <Tooltip title={action.name} key={index}>
            <span>
              <IconButton
                className="p-2"
                onClick={action.onClick}
                disabled={selectedDoc}
              >
                {action.icon}
              </IconButton>
            </span>
          </Tooltip>
        ))}
      </div>
    </>
  );
};

export default CoreSpeedDial;
